import React from 'react';

import { Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

import type { AlineButtonProps } from '.';
import { AlineButton } from '.';

const useStyles = makeStyles()(theme => ({
  button: {
    // Use marginTop vs. padding as margin keeps the loading spinner centered.
    marginTop: theme.spacing(2),
  },
  container: {
    paddingTop: 60,
  },
  subtitle: { marginTop: theme.spacing(1), maxWidth: 360 },
  title: { marginTop: theme.spacing(2), maxWidth: 360 },
}));

interface EmptyStateProps extends React.HTMLAttributes<HTMLElement> {
  buttonProps?: AlineButtonProps;
  buttonText?: string;
  icon?: JSX.Element | null;
  subtitle?: string;
  subtitleClassName?: string;
  title?: string;
  titleClass?: string;
}

export function EmptyState({
  buttonProps,
  buttonText,
  className,
  icon = null,
  subtitle,
  subtitleClassName,
  title,
  titleClass,
}: EmptyStateProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <Grid
      container
      className={clsx(classes.container, className)}
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {icon}
      {title && (
        <Typography align="center" className={clsx(classes.title, titleClass)} variant="subtitle1">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          align="center"
          className={clsx(classes.subtitle, subtitleClassName)}
          variant="body1"
        >
          {subtitle}
        </Typography>
      )}
      {buttonText && (
        <AlineButton
          className={classes.button}
          color="primary"
          variant="contained"
          {...buttonProps}
        >
          {buttonText}
        </AlineButton>
      )}
    </Grid>
  );
}
